{
    "SCOPEASSIGNMENT_CME": "CME :",
    "SCOPEASSIGNMENT_FilterRecursively": "Filtre récursif :",
    "SCOPEASSIGNMENT_TelServer": "Serveur de téléphonie :",
    "SCOPEASSIGNMENT_Partition": "Partition :",
    "NAME": "ScopeAssignment"
}